export default "__VITE_ASSET__ba8557a0__"